// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bMoPZ","heading":"m8mhi","skeletonCityWrap":"_1tTxW","flexItem":"_1FCDA","skeletonCityIcon":"WfkPM","skeletonCityName":"_3Xlk0"};